module.exports = "/images/vendor/desiigner-svg/svg/places/toucan.svg?758d1a63a93104bd06e4b22189016db8";